import { useState, useEffect } from 'react';
import css from './index.module.scss';
import NextImage from '@/components/NextImage';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta2max.teaser');
    const { locale } = useRouter();
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setEnter(true);
        }, 500);
    }, []);

    const imgWebp = locale === 'za' ? `/${locale}/kv.jpg` : '/us/kv.webp';
    const imgJpg = locale === 'za' ? `/${locale}/kv.jpg` : '/us/kv.jpg';

    return (
        <div className={`d2x-teaser-A ${css.d2xTeaserA}`}>
            <div className={`top-tip ${enter ? 'enter' : ''}`}>{t('sec1_note')}</div>
            <div className="img-wrapper">
                <NextImage
                    webpSrc={require(`@publicLocal/delta2max/teaser/h5${imgWebp}`)}
                    src={require(`@publicLocal/delta2max/teaser/h5${imgJpg}`)}
                    alt={t('sec1_title')}
                    aria-label={t('sec1_title')}
                />
            </div>
            <div className="reddot">
                <NextImage
                    webpSrc={require('@publicLocal/delta2max/reddot.webp')}
                    src={require('@publicLocal/delta2max/reddot.png')}
                    alt={t('sec1_title')}
                    aria-label={t('sec1_title')}
                />
            </div>
            <div className="text-wrapper">
                {locale === 'za' && <p className="date desc">{t('sec1_date')}</p>}
                <p className="title">{t('sec1_title')}</p>
                <p className="desc">{t('sec1_desc')}</p>
                {locale !== 'za' && <p className="date desc">{t('sec1_date')}</p>}
            </div>
        </div>
    );
}
